import SearchPlatforms from '@/constants/SearchPlatforms';

export default {
  SearchPlatforms: Object.values(SearchPlatforms),
  DefaultLanguage: 'en',
};
